import React from 'react';
import * as d3 from 'd3';
import cloud from 'd3-cloud';

export default class WordCloud extends React.Component {
    constructor(props) {
      super(props)
      
      this.state = {
        usData: null,
        tweets: null,
      }
      this.anchor = React.createRef();
    }

	componentDidMount() {
	    const url = ["https://aukt2i8vp5.execute-api.us-east-1.amazonaws.com/Prod/main"]
	    const opts = {"type": "queryTweets", "airline": "Virgin America", "isAll": false};

	    Promise.all([
	      fetch(url[0], {
	        method: 'post',
	        body: JSON.stringify(opts)
	      })
	      .then(data => data.json())
	      .catch((e) => console.log(e)),
	    ])
	    .then((results) => {
	      
	      const data = JSON.parse(JSON.parse(results[0].tweets));
	      
	      // console.log(text)
	      const tweets = data
	      // console.log(tweets)
	      this.setState({tweets: tweets})
	      this.buildSvg();
    	  this.setWordCloud(tweets)
	    });
    }

    componentDidUpdate() {
    	// this.updateAirports()
    	if (this.props.tweets === null) {
    		this.setWordCloud(this.state.tweets)	
    	}
    	else {
    		this.setWordCloud(this.props.tweets)	
    	}
    	

    // 	[
    //   "Hello", "world", "normally", "you", "want", "more", "words",
    //   "than", "this"].map(function(d) {
    //   return {text: d, size: 10 + Math.random() * 90, test: "haha"};
    // })
    }

    buildSvg() {
    	var getRatio = (side, margin) => {
      		return (( margin[side] / width ) * 100 + 1) + "%";
 		}

	    var margin = {left: 5, top: 10, right: 10, bottom: 10},
	    	width = 600 - margin.left - margin.right,
	      	height = 300 - margin.top - margin.bottom,
	      	marginRatio = {
	        	left: getRatio("left", margin),
	          	top: getRatio("top", margin),
	          	right: getRatio("right", margin),
	          	bottom: getRatio("bottom", margin)
	      	};

    	d3.select(this.anchor.current)
      		.append("svg")
      		.style("padding", marginRatio.top + " " + marginRatio.right + " " + marginRatio.bottom + " " + marginRatio.left)
      		.style("background-color", 'black')
      		.style("margin-left", 70 + 'px')
			.attr("preserveAspectRatio", "xMinYMin meet")
			.attr("viewBox", "0 0 " + ( width + margin.left + margin.right  ) + " " + ( height + margin.top + margin.bottom ))
			.attr("id", "svg-cloud")
			.attr("class", "graph-svg-placeholder");

		d3.select("#svg-cloud")
				.attr("width", width)
				.attr("height", height)
				.append("g")
				.attr("transform", "translate(" + 600 / 2 + "," + 300 / 2 + ")")
				.attr("id", "cloud-g")
    }
    

	setWordCloud(tweets) {
		

		var layout = cloud()
		    .size([600, 300])
		    .words(tweets)
		    .padding(5)
		    .rotate(function() { return ~~(Math.random() * 2) * 90; })
		    .font("Impact")
		    .fontSize(function(d) { return d.frequency; })
		    .on("end", draw)

		
		    
		layout.start();
		
		function draw(words) {
			// var colors = ["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"];
			var color = d3.scaleOrdinal(d3.schemeSpectral[9]);
	
			const cloud = d3.select("#cloud-g")
				.selectAll("text")
				.data(words, (d) => {return d.text})

			//Exiting words
			cloud.exit()
			.attr("class", "exit")
			.transition()
			    .duration(100)
			    .style('fill-opacity', 0)
			    .attr('font-size', 1)
			    .remove();

			//Entering and existing words
			cloud
			.attr("class", "update")
			.transition()
			    .duration(100)
			    .style("font-size", function(d) { return d.frequency * 3 + 10 + "px"; })
						.style("fill", function(d,i) { return color(i); })
			    .attr("transform", function(d) {
			        return "translate(" + [d.x, d.y] + ")";
			    })
			    .style("fill-opacity", 1);

			//Entering words
			cloud.enter()
			.append("text")
			.attr("class", "enter")
			.transition()
			.duration(100)
			.style("font-size", function(d) { return d.frequency * 3 + 10 + "px"; })
			.style("fill", function(d,i) { return color(i); })
			.attr("transform", function(d) {
			return "translate(" + [d.x, d.y] + ")";
			})
			.style("fill-opacity", 1)
			.attr("text-anchor", "middle")
			.attr('font-size', 1)
			.text(function(d) { return d.text; });
// "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
			

			
		}

		

	}


    

    render() {
        return (
        	<React.Fragment>
        	<div ref={this.anchor} style={{marginTop: -30}}/>
        	</React.Fragment>
        );
    }
}